import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/constants';

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity } = useCart();

  const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

  if (cartItems.length === 0) {
    return <div className="flex items-center justify-center min-h-[40vh] text-2xl">Vaša korpa je prazna.</div>;
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Vaša korpa</h1>

      <div className="space-y-6">
        {cartItems.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-between border-b pb-4 gap-4"
          >
            <div className="flex items-center gap-4">
              {(
                <img
                  src={item.images.length > 0 ? `${API_BASE_URL}/uploads/${item.images[0].filename}` : item.image_url}
                  alt={item.name}
                  className="w-20 h-20 object-cover border rounded"
                />
              )}
              <div>
                <h3 className="font-semibold">{item.subname ? item.subname : item.product_name}</h3>
                <div className="text-sm text-gray-600">
                  {parseFloat(item.price).toFixed(2)} rsd × {item.quantity}
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <button
                    onClick={() =>
                      updateQuantity(item.id, Math.max(1, item.quantity - 1))
                    }
                    className="px-2 py-1 border rounded"
                  >
                    −
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="px-2 py-1 border rounded"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <button
              onClick={() => removeFromCart(item.id)}
              className="text-red-500 text-2xl hover:scale-110 transition-transform"
              aria-label="Remove"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {/* Buttons + Total */}
      <div className="mt-8 flex items-center justify-between">
        <div className="flex gap-4">
          <Link
            to="/shop"
            className="px-4 py-2 border border-gray-400 rounded hover:bg-gray-100"
          >
            Nastavi kupovinu
          </Link>
          <Link
            to="/checkout"
            className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
          >
            Izvrši kupovinu
          </Link>
        </div>
        <div className="text-xl font-semibold">Total: {total.toFixed(2)} rsd</div>
      </div>
    </div>
  );
};

export default Cart;
